import { Component, OnInit } from '@angular/core';
import { ChangeDetectionStrategy, ChangeDetectorRef } from '@angular/core';
import { FormControl, FormGroup, Validators } from '@angular/forms';

@Component({
    selector: 'demo-upp-input-select',
    templateUrl: './demo-upp-input-select.html',
    styleUrls: ['../demo-common.scss', './demo-upp-input-select.scss'],
    changeDetection: ChangeDetectionStrategy.OnPush
})
export class DemoUppInputSelectComponent implements OnInit {
    form!: FormGroup;

    printers = ['POS80', 'POS-80C', 'CommandViewer'];

    errorMessages: Record<string, string> = {
        required: 'This field is required',
    };

    constructor(private change: ChangeDetectorRef) {
    }

    ngOnInit(): void {
        this.form = new FormGroup({
            device: new FormControl<string | null>(null, [Validators.required]),
            free: new FormControl<string | null>('custom-name'),
        });
    }

    clearOptions(): void {
        this.printers = [];
        this.change.markForCheck();
    }

    restoreOptions(): void {
        this.printers = ['POS80', 'POS-80C', 'CommandViewer'];
        this.change.markForCheck();
    }
}
